import { render, staticRenderFns } from "./Add3.vue?vue&type=template&id=87827e54"
import script from "./Add3.vue?vue&type=script&lang=js"
export * from "./Add3.vue?vue&type=script&lang=js"
import style0 from "./Add3.vue?vue&type=style&index=0&id=87827e54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports